import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useGetLSPSStateQuery } from "./operatorDashboardAPISlice";
import LSPSStatusChip from "./LSPSStatusChip";
import { LSPS } from "./lspsSwitch";

/** Read-only Load Shifting / Peak Shaving status for every Operator header (NEU-1226).
 *  It was the switches themselves, one click from changing the whole fleet from any page;
 *  they now live in Settings behind a type-CONFIRM dialog. */
export default function LSPSStatus() {
  // Polled so Standby / Active follow the schedules without a reload.
  const { data: state, isError } = useGetLSPSStateQuery(undefined, { pollingInterval: 60000 });
  if (!state || isError) return null;

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: "14px", mr: "8px" }}>
      {[LSPS.peak_shaving, LSPS.load_shifting].map(({ name, field, activeKey }) => (
        <Box key={field} sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <Typography component="span" sx={{ fontSize: "0.82rem", color: "rgba(255,255,255,0.65)", fontWeight: 500 }}>
            {name}
          </Typography>
          <LSPSStatusChip name={name} on={!!state[field]} active={!!state[activeKey]} />
        </Box>
      ))}
    </Box>
  );
}
